import { render, staticRenderFns } from "./RangeColors.vue?vue&type=template&id=7dadd4e4"
import script from "./RangeColors.vue?vue&type=script&lang=js"
export * from "./RangeColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports